import React from 'react';
import { faLightbulb } from '@fortawesome/free-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import styles from './ToolTipBulb.module.css';
import { CommonButton } from './CommonButton';


export class ToolTipBulb extends React.Component {

    showContent() {
        document.getElementById('tooltip_content_' + this.props.uid).style.opacity = '1';
    }

    hideContent() {
        document.getElementById('tooltip_content_' + this.props.uid).style.opacity = '0';
    }

    renderContent() {
        let width = this.props.width ? this.props.width : 300;
        let position = this.props.position ? this.props.position : 'right';
        let leftPos = position === 'left' ? -1 * this.props.width : 25;
        return (
            <span id={'tooltip_content_' + this.props.uid} className={styles.content_wrapper} style={{ width: width, left: leftPos }} >
                <div className={styles.inner_wrapper}>
                    <div className={styles.inner_icon}>
                        <FontAwesomeIcon icon={faLightbulb} />
                    </div>
                    <div className={styles.inner_content_wrapper}>
                        {this.props.children}
                    </div>
                </div>
            </span>
        );
    }


    render() {
        return (
            <span className={styles.tool_tip_wrapper}>
                <span className={styles.icon_wrapper} onMouseOver={() => this.showContent()} onMouseOut={() => this.hideContent()}>
                    <CommonButton title={this.props.title ? this.props.title : ''} size={this.props.size ? this.props.size : 'extra-small'} className={styles.button} >
                        <FontAwesomeIcon icon={faLightbulb} style={{ zIndex: -999 }}/>
                    </CommonButton>
                </span>
                {this.renderContent()}
            </span>
        );
    }
}
